export default __webpack_public_path__ + "static/media/home-logo.e81dd037.png";